export default "__VITE_ASSET__0a2b8990__"